/* eslint-disable no-useless-escape */
const isPhoneValid = (phone) => {
  const regEx = /\d{10,20}/;
  return regEx.test(phone);
};

// Igual que trakku-admin: acepta alias con + y dominios largos (.online, .com.co).
const isEmailValid = (email) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email);

export const inputValidations = {
  isPhoneValid,
  isEmailValid,
};
